var __extends = this.__extends || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    __.prototype = b.prototype;
    d.prototype = new __();
};
var React = require('react');
var ReactCurrentOwner = require('react/lib/ReactCurrentOwner');
var ExecutionEnvironment = require('react/lib/ExecutionEnvironment');
exports.FreeStyle = require('free-style');
/**
 * Create a specialized free style instance.
 */
var ReactFreeStyle = (function (_super) {
    __extends(ReactFreeStyle, _super);
    function ReactFreeStyle() {
        _super.apply(this, arguments);
        /**
         * Expose the `StyleElement` for use.
         *
         * @type {StyleElement}
         */
        this.Element = StyleElement;
    }
    /**
     * Override emit change to warn when changing styles during render.
     *
     * @param {string}              type
     * @param {FreeStyle.StyleType} style
     */
    ReactFreeStyle.prototype.emitChange = function (type, style) {
        if (ReactCurrentOwner.current != null) {
            console.warn('Inline styles must be registered before `render`');
            return;
        }
        return _super.prototype.emitChange.call(this, type, style);
    };
    /**
     * Wrap a React component in a higher order `ReactFreeStyle` component.
     *
     * @param  {React.ComponentClass<any>} component
     * @return {React.ComponentClass<any>}
     */
    ReactFreeStyle.prototype.component = function (component) {
        /**
         * Alias `free-style` instance for changes.
         */
        var freeStyle = this;
        /**
         * Create a higher order style component.
         */
        var ReactFreeStyleComponent = React.createClass({
            displayName: 'ReactFreeStyle',
            contextTypes: {
                freeStyle: React.PropTypes.object
            },
            childContextTypes: {
                freeStyle: React.PropTypes.object.isRequired
            },
            getChildContext: function () {
                return {
                    freeStyle: this._parentFreeStyle
                };
            },
            getInitialState: function () {
                return { freeStyle: freeStyle };
            },
            componentWillUpdate: function () {
                // Hook into component updates to keep styles in sync over hot code
                // reloads. This works great with React Hot Loader!
                if (module.hot && this.state.freeStyle.id !== freeStyle.id) {
                    this._parentFreeStyle.attach(freeStyle);
                    this._parentFreeStyle.detach(this.state.freeStyle);
                    this.state.freeStyle = freeStyle;
                }
            },
            componentWillMount: function () {
                this._parentFreeStyle = this.context.freeStyle || new ReactFreeStyle();
                this._parentFreeStyle.attach(this.state.freeStyle);
            },
            componentWillUnmount: function () {
                this._parentFreeStyle.detach(this.state.freeStyle);
            },
            render: function () {
                return React.createElement(component, this.props);
            }
        });
        return ReactFreeStyleComponent;
    };
    return ReactFreeStyle;
})(exports.FreeStyle.FreeStyle);
exports.ReactFreeStyle = ReactFreeStyle;
/**
 * Create the <style /> element.
 */
var StyleElement = (function (_super) {
    __extends(StyleElement, _super);
    function StyleElement() {
        var _this = this;
        _super.apply(this, arguments);
        this.onChange = function () { return _this.forceUpdate(); };
    }
    StyleElement.prototype.componentWillMount = function () {
        if (ExecutionEnvironment.canUseDOM) {
            this.context.freeStyle.addChangeListener(this.onChange);
        }
    };
    StyleElement.prototype.componentWillUnmount = function () {
        if (ExecutionEnvironment.canUseDOM) {
            this.context.freeStyle.removeChangeListener(this.onChange);
        }
    };
    StyleElement.prototype.render = function () {
        return React.createElement('style', {
            dangerouslySetInnerHTML: { __html: this.context.freeStyle.getStyles() }
        });
    };
    StyleElement.displayName = 'Style';
    StyleElement.contextTypes = {
        freeStyle: React.PropTypes.object.isRequired
    };
    return StyleElement;
})(React.Component);
exports.StyleElement = StyleElement;
function create() {
    return new ReactFreeStyle();
}
exports.create = create;
//# sourceMappingURL=react-free-style.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-free-style/dist/react-free-style.js
// module id = 635
// module chunks = 0